import React from "react";

const AllReports = () => {
  return (
    <div>
      <h1>this is all Reports</h1>
    </div>
  );
};

export default AllReports;
